if (!customElements.get('product-info')) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super()
        this.shopifyProduct = JSON.parse(this.querySelector(`[data-product-json]`).innerHTML)
        this.input = this.querySelector(".quantity__input")
        this.currentVariant = this.querySelector(".product-variant-id")
        this.variantSelects = this.querySelector("variant-radios")
        this.submitButton = this.querySelector('[type="submit"]')
        this.promoMessagesContainer = this.querySelector(`[data-product-promo-messages]`)

        this.availableQuantity = 0

        this.sku = Number.parseInt(this.dataset.gopuffProductId)
        if (!this.sku) return

        this.quantityPill = this.querySelector("quantity-pill")
        if (!this.quantityPill) return

        this.fulfillmentTypeIndicator = this.querySelector(`.product__info-fulfillment-type`)
        this.availabilityTextEl = this.querySelector(".product__info-availability-text")
        this.availabilityQuantityEl = this.querySelector(".product__info-availability-quantity")
        this.productAvailable = null
        this.priceContainer = this.querySelector(".product__info-price")

        this.loading = true
        this.updateDeliveryTypeMessaging()
        if (bevmoLocation?.location_id) {
          this.checkProductAvailability()
        }
        subscribe(PUB_SUB_EVENTS.bevmoLocationUpdate, () => {
          // Ensure location_id is available before checking availability
          // This is necessary because setLocation() is async and might not be complete when event fires
          if (bevmoLocation?.location_id) {
            this.checkProductAvailability()
          } else {
            // Retry after a short delay if location_id is not yet set
            setTimeout(() => {
              if (bevmoLocation?.location_id) {
                this.checkProductAvailability()
              }
            }, 200)
          }
        })
      }

      cartUpdateUnsubscriber = undefined
      variantChangeUnsubscriber = undefined

      // Getter for safe access to bevmoLocation state
      get currentLocationState() {
        return window.bevmoLocation?.storefrontLocationState
      }

      updateDeliveryTypeMessaging() {
        this.fulfillmentTypeIndicator.classList.remove(`product__info-fulfillment-type--available`)
        const delivery_type = bevmoLocation.fulfillment_type
        const fulfillment_display_name = bevmoLocation.fulfillment_display_name

        this.querySelectorAll("[data-delivery-type]").forEach((item) => {
          if (item.dataset.deliveryType == delivery_type) {
            item.classList.remove("hidden")
          } else {
            item.classList.add("hidden")
          }
        })

        if (this.productAvailable != null) {
          if (bevmoLocation.hasAddress()) {
            if (this.availabilityQuantityEl) {
              this.availabilityQuantityEl.innerHTML = this.productAvailable
                ? `${this.availableQuantity} in stock`
                : "Out of stock"
            }
          }

          if (this.productAvailable && bevmoLocation.hasAddress()) {
            if (this.fulfillmentTypeIndicator) {
              this.fulfillmentTypeIndicator.classList.add(`product__info-fulfillment-type--available`)
            }
          }

          if (this.availabilityTextEl) {
            switch (delivery_type) {
              case "pickup":
                this.availabilityTextEl.innerHTML =
                  (this.productAvailable ? `Available` : "Unavailable") + ` at ${fulfillment_display_name}`
                break
              case "delivery":
                this.availabilityTextEl.innerHTML =
                  (this.productAvailable
                    ? `Instant delivery through <svg aria-label="gopuff" class="icon icon-gopuff-inline" width="55" height="22"><use xlink:href="#svg-gopuff"></use></svg> to`
                    : "Unavailable at") + ` ${fulfillment_display_name}`
                break
              case "shipping":
                this.availabilityTextEl.innerHTML =
                  (this.productAvailable ? `Ship to` : "Unavailable at") + ` ${fulfillment_display_name}`
                break
            }
          }
        }

        if (!bevmoLocation.hasAddress()) {
          if (this.availabilityTextEl) {
            this.availabilityTextEl.innerHTML = `Enter address to check <svg aria-label="gopuff" class="icon icon-gopuff-inline" width="55" height="22"><use xlink:href="#svg-gopuff"></use></svg> instant delivery available`
          }
        }
      }

      // `isClubBevPrice` decides the label, not the presence of a sale price: a
      // script promo is an ordinary sale, the ClubBev price is not.
      renderPrice(price, offer, isClubBevPrice = false) {
        if (offer) {
          this.priceContainer.classList.add("price--on-sale")
          const salePriceContainer = this.priceContainer.querySelector(".price__sale")
          salePriceContainer.querySelector(".price-item--regular").innerHTML = `${globalMoneyFormatter.format(price)}`
          salePriceContainer.querySelector(".price-item--sale").innerHTML =
            `${globalMoneyFormatter.format(offer)}${isClubBevPrice ? ` ClubBev!` : ``}`

          return
        }

        this.priceContainer.classList.remove("price--on-sale")
        this.priceContainer.querySelector(".price-item--regular").innerHTML = `${globalMoneyFormatter.format(price)}`
      }

      getPromoDetails(tags = ``) {
        const promoMessages = this.getPromoMessages(tags)
        const promoDetails = promoMessages.filter((promo) => {
          return promo.price_details_message
        })

        return promoDetails
      }

      renderPriceDetails(promosDetails) {
        this.priceContainer.classList.remove("price--promo")
        const infoIconSvg = `<svg class="info-icon-pdp" width="24" height="24" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 7C14.5 10.866 11.366 14 7.5 14C3.63401 14 0.5 10.866 0.5 7C0.5 3.13401 3.63401 0 7.5 0C11.366 0 14.5 3.13401 14.5 7ZM7.5 13.1737C10.9096 13.1737 13.6737 10.4096 13.6737 7C13.6737 3.59035 10.9096 0.826284 7.5 0.826284C4.09035 0.826284 1.32628 3.59035 1.32628 7C1.32628 10.4096 4.09035 13.1737 7.5 13.1737Z" fill="currentColor" fill-opacity="0.75"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.19189 3.55353C8.19189 3.16326 7.91572 2.82899 7.50163 2.82899C7.09256 2.82899 6.80626 3.15786 6.80626 3.55353C6.80626 3.94642 7.09511 4.27259 7.50163 4.27259C7.9132 4.27259 8.19189 3.94104 8.19189 3.55353Z" fill="currentColor" fill-opacity="0.75"/>
          <path d="M6.97141 5.72371C6.97141 5.54117 7.11938 5.3932 7.30192 5.3932H7.69854C7.88107 5.3932 8.02905 5.54117 8.02905 5.72371V10.8467C8.02905 11.0292 7.88107 11.1772 7.69854 11.1772H7.30192C7.11938 11.1772 6.97141 11.0292 6.97141 10.8467V5.72371Z" fill="currentColor" fill-opacity="0.75"/>
        </svg>`
        const isShowOnlyRequired = promosDetails.some((promo) => promo?.show_only_this_message_price)

        this.priceContainer.querySelector(".price__promo-text").innerHTML = promosDetails
          .filter((promo) => promo.price_message && (!isShowOnlyRequired || promo.show_only_this_message_price))
          .map((promo) => promo.price_message.replace(`<span>**</span>`, infoIconSvg))
          .join(`, `)

        const promoText = promosDetails
          .filter((promo) => promo.price_details_message && (!isShowOnlyRequired || promo.show_only_this_message_price))
          .map((promo) => `${promo.price_details_message}`)
          .join(`<br />`)

        this.priceContainer.classList.add("price--promo")

        const infoIcon = this.querySelector(".info-icon-pdp")
        if (infoIcon) {
          this.tooltip = document.createElement("div")
          this.tooltip.className = "tooltip hidden"
          this.tooltip.textContent = promoText
          document.body.appendChild(this.tooltip)

          // Event handlers
          infoIcon.addEventListener("mouseenter", (e) => this.showTooltip(e))
          infoIcon.addEventListener("mouseleave", () => this.hideTooltip())
          infoIcon.addEventListener("focus", (e) => this.showTooltip(e))
          infoIcon.addEventListener("blur", () => this.hideTooltip())
        }
      }

      showTooltip(e) {
        const iconRect = e.target.getBoundingClientRect()
        this.tooltip.style.top = `${iconRect.top + window.scrollY - 30}px`
        this.tooltip.style.left = `${iconRect.left + window.scrollX + 12}px`
        this.tooltip.classList.remove("hidden")
      }

      hideTooltip() {
        this.tooltip.classList.add("hidden")
      }

      togglePromo(e) {
        const ctaLink = e.currentTarget.querySelector(`.promo-message__cta-container a`)

        if (ctaLink) {
          e.preventDefault()
          e.stopPropagation()
          document.location.href = ctaLink.href
          return
        }

        const promo = e.currentTarget
        const isClosing = promo.classList.contains(`promo-message--open`)
        const isOpening = !isClosing

        promo.classList.toggle(`promo-message--open`, isOpening)
        promo.setAttribute(`aria-expanded`, isOpening)
      }

      setPromoListeners(isSetup = true) {
        const promos = this.querySelectorAll(`[data-toggle-promo]`)

        if (!isSetup) {
          promos.forEach((promoEl) => {
            promoEl.removeEventListener(`click`)
            promoEl.removeEventListener(`keydown`)
          })

          return
        }

        promos.forEach((promoEl) => {
          promoEl.addEventListener(`click`, this.togglePromo)
          promoEl.addEventListener(`keydown`, (e) => {
            if (e.key !== `Enter` && e.key !== ` `) {
              return
            }

            this.togglePromo(e)
          })
        })
      }

      getPromoMessage(promo, promoIndex) {
        const heading = [promo.message_heading, promo.message_summary].filter(Boolean).join(` `).trim()

        if (!heading) {
          return ``
        }

        return `
        <li
          id="promoMessage--${promoIndex}"
          class="product__info-promo-message promo-message"
          tabindex="0"
          aria-expanded="false"
          role="button"
          aria-controls="promoMessage__full-details--${promoIndex}"
          data-toggle-promo
        >
          <div class="promo-message__image-container">
            <div class="promo-message__image">
              <svg
                class="icon icon-bevmo"
                aria-label="Bevmo"
                width="39"
                height="38"
                viewBox="0 0 39 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <use xlink:href="#svg-bevmo"></use>
              </svg>
            </div>
          </div>
          <div class="promo-message__main">
            <div class="promo-message__heading">${heading}</div>
            <div class="promo-message__primary-details">${promo.expiration}</div>
            ${
              promo.details
                ? `<div
              class="promo-message__full-details"
              id="promoMessage__full-details--${promoIndex}"
              aria-labelledby="promoMessage--${promoIndex}"
            >
              ${promo.details}
            </div>
            <div class="promo-message__toggle-text link">
              <span class="promo-message__toggle-text-closed">More details</span>
              <span class="promo-message__toggle-text-open">Less details</span>
            </div>`
                : ``
            }
            ${
              !promo.details && !promo.expiration && (!!promo.cta_message || !!promo.cta_url)
                ? `<div class="promo-message__cta-container">
              <a href="${promo.cta_url || `#`}">${promo.cta_message || `More details`} <svg viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#svg-icon-arrow"></use></svg></a>
            </div>`
                : ``
            }
          </div>
        </li>`
      }

      getPromoMessages(tags = ``) {
        const allPromoMessages = window.gopuffShopify.productPromoMessages || []
        const storePromoMessages = allPromoMessages.filter((promo) => {
          return (
            !promo.stores_select ||
            (window.getCurrentLocationState() && promo.stores_select === window.getCurrentLocationState())
          )
        })

        const productPromoMessages = storePromoMessages.filter((promo) => {
          const isProductTagMatching = Boolean(tags.toLowerCase().split(`, `).indexOf(promo.tag.toLowerCase()) > -1)
          return promo.is_pdp_enabled && (!promo.tag || isProductTagMatching)
        })

        if (window.getCurrentLocationState()) {
          const activeOffersKey = `activeOffers${window.getCurrentLocationState().toUpperCase()}`

          if (
            window.gopuffShopify.productOffers &&
            window.gopuffShopify.productOffers[activeOffersKey] &&
            window.gopuffShopify.productOffers.activeBuyOffers &&
            window.gopuffShopify.productOffers.activeGetOffers
          ) {
            const activeOffers = window.gopuffShopify.productOffers[activeOffersKey] || {}
            const matchingOffers = Object.keys(activeOffers)
              .filter(
                (offerId) =>
                  window.gopuffShopify.productOffers.activeBuyOffers.includes(offerId) &&
                  window.gopuffShopify.productOffers.activeGetOffers.includes(offerId)
              )
              .map((offerId) => {
                const offerConfig = activeOffers[offerId]

                return this.formatOffer(offerConfig)
              })
            matchingOffers.forEach((promo, promoIndex) => {
              productPromoMessages.push(promo)
            })
          }
        }

        return productPromoMessages
      }

      formatOffer(offer = {}) {
        const discountDollars = offer.discount / 100
        const discountString = Number.parseFloat(
          offer.type === `PRICE_POINT` ? discountDollars * Number.parseInt(offer.buy_qty, 10) : discountDollars
        )
          .toFixed(2)
          .replace(`.00`, ``)
        const offerText =
          offer.type === `PRICE_POINT`
            ? `Buy ${offer.buy_qty} for $${discountString}`
            : `Buy ${offer.buy_qty}, Save $${discountString}`
        const perPrice = Number.parseFloat(
          offer.type === `PRICE_POINT`
            ? discountDollars
            : (this.product.offer || this.product.price) - discountDollars / offer.buy_qty
        )
          .toFixed(2)
          .replace(`.00`, ``)

        return {
          message_heading: offerText,
          price_details_message: `${offerText} ($${perPrice} ea)`,
          price_details_color: `#da291c`,
          expiration:
            (offer.sets > 0 ? `Limit ${offer.sets}.` : `No limit.`) +
            ` Limited time offer. Offer applied automatically at checkout.`,
        }
      }

      renderPromoMessages(tags = ``) {
        const productPromoMessages = this.getPromoMessages(tags)

        const nonEmptyProductPromoMessages = productPromoMessages.filter(
          (promo) => !![promo.message_heading, promo.message_summary].filter(Boolean).join(` `).trim()
        )

        this.promoMessagesContainer.innerHTML = ``
        let promoMessagesHTML = ``

        const isShowOnlyRequired = nonEmptyProductPromoMessages.some(
          (promo) => promo?.show_only_this_message_promo_section
        )
        const nonEmptyProductPromoMessagesToShow = nonEmptyProductPromoMessages.filter(
          (promo) => !isShowOnlyRequired || promo.show_only_this_message_promo_section
        )

        nonEmptyProductPromoMessagesToShow.forEach((promo, promoIndex) => {
          promoMessagesHTML += this.getPromoMessage(promo, promoIndex)
        })

        if (!promoMessagesHTML) {
          return
        }

        this.promoMessagesContainer.innerHTML = `
        <h3 class="product__section-heading">Available Coupons & Sales</h3>
        <ul class="product__info-promo-messages-list list-unstyled">${promoMessagesHTML}</ul>`

        this.setPromoListeners()
      }

      updateQuantityPill(quantity = 0, shopify_variant_id) {
        this.quantityPill.max = quantity

        // The variant rendered by Liquid wins over the API's `shopify_variant_id`.
        // Storefront variants are already scoped to the Online Store channel, so
        // Liquid's is the purchasable one by definition and is read straight from
        // Shopify. The API's comes from a Redis cache keyed per product, which can
        // outlive the variant it points at — a catalog sync that recreates variants
        // leaves it pointing at a deleted id, and add-to-cart then fails with
        // "Cannot find variant". Only fall back to it when Liquid had no product.
        const liquidVariantId = Number.parseInt(this.quantityPill.dataset.variantId, 10)
        const variantId = Number.isInteger(liquidVariantId) ? liquidVariantId : shopify_variant_id

        if (variantId) {
          this.quantityPill.variantId = variantId
        } else {
          this.quantityPill.variantId = null
          this.quantityPill.cartQuantity = 0
          this.quantityPill.max = 0
        }

        this.availableQuantity = this.quantityPill.max
        this.productAvailable = this.quantityPill.max > 0
        this.quantityPill.validateQtyRules()
      }

      async getProductData() {
        // Ensure location_id is a number, not a string
        const locationId = bevmoLocation.location_id ? Number(bevmoLocation.location_id) : null

        // Don't make the request if we don't have a valid location_id for pickup
        if (bevmoLocation.fulfillment_type === "pickup" && !locationId) {
          console.warn("Cannot fetch product data: missing location_id for pickup")
          return null
        }

        const params = {
          ids: [this.sku],
          fulfillment_type: bevmoLocation.fulfillment_type,
          location_id: locationId,
          shopify_shop_domain: Shopify.shop,
          unified: window.gopuffShopify.settings.unified_products,
        }

        try {
          const response = await fetch(`${window.gopuffShopify.settings.api_base_url}/shops/products`, {
            ...fetchConfig(),
            ...{ body: JSON.stringify(params) },
          })
          const responseJSON = await response.json()
          const product = responseJSON.products && responseJSON.products[0] ? responseJSON.products[0] : null

          return product
        } catch (e) {
          gopuffCustomAnalytics.publishEndpointError(`/shops/products`)
        }
      }

      async checkProductAvailability() {
        try {
          const product = await this.getProductData()

          // If getProductData returns null, don't process further
          if (!product) {
            this.loading = false
            return
          }

          this.product = product
          this.loading = false

          this.promoMessages = this.getPromoMessages(product.tags)

          const scriptPricePromo = this.promoMessages.find(
            (promo) => promo.script_percentage_off && Number(promo.script_percentage_off) > 0
          )
          // `offer` off the API is the ClubBev price, which only a member may be
          // shown. Assigned back onto the product because the vendor-offer copy
          // below prices its "each" figure off it.
          const sale = window.clubBevPricing.salePrice(
            product,
            scriptPricePromo ? scriptPricePromo.script_percentage_off : 0
          )
          product.offer = sale.price

          this.renderPrice(product.price, sale.price, sale.isClubBevPrice)
          this.renderPriceDetails(this.getPromoDetails(product.tags))
          this.renderPromoMessages(product.tags)
          this.updateQuantityPill(product.quantity, product.shopify_variant_id)
          this.updateDeliveryTypeMessaging()
        } catch (e) {
          console.error("Error in product availability check", e)
          this.availabilityError = (this.availabilityError || 0) + 1
          if (this.availabilityError < 3) {
            setTimeout(this.checkProductAvailability.bind(this), 1000)
          } else {
            this.availabilityTextEl.innerHTML = `Error in checking availability. Please try again later.`
          }
        }
      }
      connectedCallback() {
        if (!this.input) return
        this.quantityForm = this.querySelector(".product-form__quantity")
        if (!this.quantityForm) return
        this.setQuantityBoundries()
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this))
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          if (event.data.sectionId !== sectionId) return
          this.updateQuantityRules(event.data.sectionId, event.data.html)
          this.setQuantityBoundries()
        })
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber()
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber()
        }
        this.setPromoListeners(false)
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        }

        let min = data.min
        const max = data.max === null ? data.max : data.max - data.cartQuantity
        if (max !== null) min = Math.min(min, max)
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step)

        this.input.min = min
        this.input.max = max
        this.input.value = min
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined)
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return
        this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden")
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text()
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, "text/html")
            this.updateQuantityRules(this.dataset.section, html)
            this.setQuantityBoundries()
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden")
          })
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`)
        const selectors = [".quantity__input", ".quantity__rules", ".quantity__label"]
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector)
          const updated = quantityFormUpdated.querySelector(selector)
          if (!current || !updated) continue
          if (selector === ".quantity__input") {
            const attributes = ["data-cart-quantity", "data-min", "data-max", "step"]
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute)
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated)
            }
          } else {
            current.innerHTML = updated.innerHTML
          }
        }
      }
    }
  )
};
